import React from 'react';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SPATestPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          🚀 SPA 模式測試頁面
        </Typography>
        
        <Typography variant="h6" color="text.secondary" paragraph>
          這個頁面展示了新的單頁應用（SPA）模式功能
        </Typography>
        
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="body1" paragraph>
            ✅ <strong>BottomBar 三個按鈕現在支持狀態保持：</strong>
          </Typography>
          <Typography variant="body2" component="div" sx={{ textAlign: 'left', ml: 2 }}>
            • 📝 <strong>筆記</strong> - 保持搜索關鍵字、月份篩選、滾動位置
            <br />
            • 🔴 <strong>3D紅球</strong> - 保持影片播放狀態、時間碼、播放速度
            <br />
            • 🔍 <strong>搜尋</strong> - 保持瀏覽記錄、篩選條件、展開狀態
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="body1" paragraph>
            🎯 <strong>智能導航規則：</strong>
          </Typography>
          <Typography variant="body2" component="div" sx={{ textAlign: 'left', ml: 2 }}>
            • 只有點擊 NO 數字鍵或影片連結才會跳轉到 MainPage
            <br />
            • 頁面切換不會刷新，狀態完全保持
            <br />
            • 大幅減少等待時間和頻繁刷新
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button 
            variant="contained" 
            size="large"
            onClick={() => navigate('/app')}
            sx={{ px: 4, fontSize: '1.1rem', py: 2 }}
          >
            🚀 進入 SPA 模式 (無刷新切換)
          </Button>
          
          <Button 
            variant="outlined" 
            size="large"
            onClick={() => navigate('/notes')}
            sx={{ px: 4, fontSize: '1.1rem', py: 2 }}
          >
            📝 傳統筆記頁面 (會刷新)
          </Button>
        </Box>
        
        <Box sx={{ mt: 3, p: 3, bgcolor: 'warning.light', borderRadius: 2 }}>
          <Typography variant="body1" color="warning.contrastText" sx={{ fontWeight: 'bold', mb: 1 }}>
            ⚠️ 重要提醒：
          </Typography>
          <Typography variant="body2" color="warning.contrastText">
            • 如果您直接訪問 <code>/notes</code>、<code>/manage</code>、<code>/v/xxx</code> 等路由，仍然是傳統模式（會刷新）
            <br />
            • 只有訪問 <code>/app</code> 路由才會進入 SPA 模式（無刷新切換）
            <br />
            • 請點擊上方的「🚀 進入 SPA 模式」按鈕來體驗新功能
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4, p: 3, bgcolor: 'grey.100', borderRadius: 2 }}>
          <Typography variant="body2" color="text.secondary">
            💡 <strong>使用說明：</strong>
            <br />
            1. 點擊「體驗 SPA 模式」進入新的單頁應用
            <br />
            2. 使用底部的三個按鈕切換頁面
            <br />
            3. 注意頁面狀態完全保持，不會刷新
            <br />
            4. 只有點擊具體的影片或 NO 鍵才會跳轉到播放頁面
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default SPATestPage;
